/**
 * Extracts content from within <passage>...</passage> tags in LLM output.
 * Handles:
 * - Leading rationale before <passage> tag
 * - Malformed close tags like </paste>, </pas>, etc.
 * - Trailing rationale after close tag
 * - Known Rewrite rationale headers even when no passage tags are present
 */
const REWRITE_RATIONALE_HEADER_PATTERN = /(?:^|\n)[ \t]*(?:#{1,6}[ \t]*)?(?:\*\*)?(?:(?:Why I applied (?:(?:the author['’]s|the) )?edit (?:the way I did|this way))|(?:Why I went about (?:it|applying (?:the )?edit) this way)|(?:How I (?:applied (?:(?:the author['’]s|the) )?edit|went about applying (?:this|the) edit)))(?:\*\*)?[ \t]*:[\s\S]*$/i;

export function stripRewriteRationale(text, { trim = true } = {}) {
  if (typeof text !== 'string') return text;

  const match = text.match(REWRITE_RATIONALE_HEADER_PATTERN);
  const stripped = match ? text.slice(0, match.index) : text;
  return trim ? stripped.trim() : stripped;
}

export function stripPassageTags(text) {
  if (typeof text !== 'string') return text;

  // Match </passage>, </paste>, </pas...> etc. (any tag starting with </pas)
  const match = text.match(/<passage>([\s\S]*?)<\/pas[^>]*>/);
  if (match) {
    return stripRewriteRationale(match[1]);
  }

  const openIdx = text.indexOf('<passage>');
  if (openIdx !== -1) {
    return stripRewriteRationale(text.slice(openIdx + '<passage>'.length));
  }

  return stripRewriteRationale(text);
}
